module.exports = __webpack_public_path__ + "img/lc.1d6b3b17.svg";